import { Skeleton } from "@mui/material";
import { Box } from "@mui/system";

/** Placeholder that mirrors the Needs Attention summary cards while Q4 is loading. */
const NeedAttentionHeaderSkeleton = () => {
  return (
    <Box sx={{ padding: "10px 16px 20px" }}>
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          width: "100%",
        }}
      >
        {Array.from({ length: 2 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              border: "1px solid #0000001F",
              borderRadius: "8px",
              padding: "8px",
              height: "96px",
              boxSizing: "border-box",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box sx={{ flex: 1 }}>
                <Skeleton width="50%" height={22} />
                <Skeleton width="80%" height={18} />
                <Box sx={{ display: "flex", gap: "16px", mt: 1 }}>
                  <Skeleton width={70} height={16} />
                  <Skeleton width={70} height={16} />
                  <Skeleton width={70} height={16} />
                </Box>
              </Box>
              <Skeleton variant="circular" width={80} height={80} />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default NeedAttentionHeaderSkeleton;
